import useLifecareStudioAutosaveBadge from '../../hooks/useLifecareStudioAutosaveBadge';

const LifecareStudioAutosaveBadge = ({ status }) => {
  const { badgeClassName, iconClassName, label } = useLifecareStudioAutosaveBadge({ status });
  return (
    <span className={badgeClassName}>
      <i className={iconClassName} />
      <span>{label}</span>
    </span>
  );
};

export default LifecareStudioAutosaveBadge;
